import React from 'react';
import DetailField from "../../common/detail-field";
import {Col, Row} from "react-bootstrap";

const incentiveDetails = ({ incentive: { id, name, startDate, endDate } }) => (
  <div className="container-fluid">
    <Col md={4}>
      <Row>
        <DetailField label="Incentive ID" lg={4}>{id}</DetailField>
        <DetailField label="Incentive name" lg={4}>{name}</DetailField>
        <DetailField label="Start date" lg={4}>{startDate}</DetailField>
        <DetailField label="End date" lg={4}>{endDate}</DetailField>
      </Row>
    </Col>
  </div>
);

export default incentiveDetails;


// WEBPACK FOOTER //
// ./src/components/admin/outlet-reward-allocation-view/incentive-details.jsx